<template>
  <div class="content-panel">
    <div class="bcg-loading" v-if="loading">
      <v-progress-circular
        class="loading-spinner"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else>
      <div class="statistics">
        <div class="stat-bar-filter">
          <div class="filter-flex-custom">
            <servis-filter-bar
              :opportunities-only="opportunitiesOnly"
              @opportunity-filter-change="setOpportunityFilter"
              @broker-filter-change="filterMortgages('financnik', $event)"
              @filter-client="filterMortgages('search', $event)"
            />
          </div>
        </div>
      </div>
      <p v-if="opportunitiesOnly && !servisMortgages.length" class="service-empty">Zatiaľ tu nie sú klienti s aktuálnym upozornením. Všetky výsledky a chýbajúce údaje zobrazíte vypnutím filtra.</p>
      <div
        data-current="Tab 1"
        data-easing="ease"
        data-duration-in="300"
        data-duration-out="100"
        class="klienti-tabs w-tabs "
      >
        <div class="tabs-content-3 w-tab-content pb-5">
          <div
            data-w-tab="Tab 1"
            data-w-id="155033eb-2d0e-aa7b-9a05-cefed74ed377"
            class="tab-pane-klienti w-tab-pane w--tab-active"
          >
            <div class="klienti-list">
              <!-- Celkový počet: {{servisMortgagesCount}} -->
              <div v-for="mortgage in servisMortgages" :key="mortgage.id">
                <serviced-mortgage :mortgage="mortgage" />
              </div>
            </div>
          </div>

          <div class="m-3 d-flex justify-content-center align-items-center"
               v-if="shouldDisplayNextPageButton()">
            <div class="loading-spinner" v-if="loadingNextPage">
              <v-progress-circular
                class="loading-spinner extrasmall"
                indeterminate
              ></v-progress-circular>
            </div>

            <span class="text-small bl-color pointer" @click="nextPage()">
              + načítaj ďalšie
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ServisFilterBar from "@/components/broker/KartaServis/ServisFilterBar.vue";
import {mapGetters} from "vuex";
import ServicedMortgage from "@/components/broker/KartaServis/ServicedMortgage.vue";

export default {
  name: "KartaServis",
  components: {ServicedMortgage, ServisFilterBar},
  async created() {
    this.loading = true;
    const page = {
      servis: 1
    }
    this.$store.commit("mortgagesState/setStagePages", page)
    this.$store.commit("mortgagesState/setMortgagesFilter", {
      key: "active_service",
      value: true,
    });

    const role = this.$store.getters["userState/getRole"];
    if (role !== "alex_admin") {
      const userId = this.$store.getters["userState/getId"];
      const filter = {
        key: "financnik",
        value: userId
      }
      this.$store.commit("mortgagesState/setMortgagesFilter", filter);
    }

    await this.$store.dispatch("mortgagesState/initializeMortgages", this.servisPageExpand);
    this.loading = false
  },
  beforeDestroy() {
    this.$store.commit("mortgagesState/setMortgagesFilter", {key: "service_opportunity", value: null});
    this.$store.commit("mortgagesState/setMortgagesFilter", {
      key: "active_service",
      value: null,
    });
  },
  computed: {
    ...mapGetters({
      mortgagesGetter: "mortgagesState/getMortgages",
      mortgagesCountGetter: "mortgagesState/getMortgagesCount",
    }),
    servisMortgages() {
      let servisMortgages = this.mortgagesGetter.servis;
      servisMortgages = this.removeWithoutApplication(servisMortgages);
      return servisMortgages;
    },
    servisMortgagesCount() {
      let servisMortgages = this.mortgagesGetter.servis;
      servisMortgages = this.removeWithoutApplication(servisMortgages);
      const countOfFilteredOut = this.mortgagesGetter.servis.length - servisMortgages.length;
      return this.mortgagesCountGetter.servis - countOfFilteredOut;
    }
  },
  methods: {
    async setOpportunityFilter(value) {
      if (this.opportunitiesOnly === value) return;
      this.opportunitiesOnly = value;
      await this.filterMortgages('service_opportunity', value || null);
    },
    async filterMortgages(key, value) {
      this.$store.commit("mortgagesState/setMortgagesFilter", {key, value});
      this.$store.commit("appState/setLoadingPage", true);
      await this.$store.dispatch("mortgagesState/fetchMortgages", this.servisPageExpand);
      this.$store.commit("appState/setLoadingPage", false);
    },
    async nextPage () {
      this.loadingNextPage = true;
      const options = {
        stage: 'servis',
        expand: this.servisPageExpand
      }
      await this.$store.dispatch("mortgagesState/nextPageMortgages", options);
      this.loadingNextPage = false;
    },
    removeWithoutApplication(mortgages) {
      return mortgages.filter((mortgage) => this.containsApplicationInStatusNacerpana(mortgage));
    },
    containsApplicationInStatusNacerpana(mortgage) {
      const applications = mortgage.applications.filter((application) => (
        this.isStatusNacerpana(application) && this.isCurrentServicedApplication(application)
      ));
      return applications.length > 0;
    },
    isCurrentServicedApplication(application) {
      const debt = application.vytvoreny_debt;
      if (!debt || typeof debt !== "object") return Boolean(debt);
      return debt.nahradeny_dlhom == null;
    },
    isStatusNacerpana(application) {
      return application.stage === "nacerpana"
    },
    shouldDisplayNextPageButton () {
      return this.servisMortgages.length !== this.servisMortgagesCount;
    }
  },
  data() {
    return {
      servisPageExpand: "coapplicant,applicant.client_profile,applications.vytvoreny_debt,applicant.debts",
      loading: true,
      loadingNextPage: false,
      opportunitiesOnly: false,
    }
  }
}
</script>

<style scoped>
.service-empty {color:var(--app-text-muted); font-size:13px; margin-bottom:24px;}

.bcg-loading {
  position: fixed;
  background-color: rgba(0, 0, 0, 25%);
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
